export var ArchiveSideBarWidth = 300;